import { formatRelativeDateForSearchApi, isRelativeDateFormat, } from '../../api/search/date/relative-date.js';
import { isDateFacetRequest, } from '../facets/range-facets/date-facet-set/interfaces/request.js';
function formatStartFacetValue(value) {
    return `start${value}`;
}
function formatEndFacetValue(value) {
    return `end${value}`;
}
export const initialSearchMappings = () => ({
    dateFacetValueMap: {},
});
function mapDateRangeRequest(value, facetId, mappings) {
    let start = value.start;
    let end = value.end;
    if (isRelativeDateFormat(start)) {
        start = formatRelativeDateForSearchApi(start);
        mappings.dateFacetValueMap[facetId][formatStartFacetValue(start)] =
            value.start;
    }
    if (isRelativeDateFormat(end)) {
        end = formatRelativeDateForSearchApi(end);
        mappings.dateFacetValueMap[facetId][formatEndFacetValue(end)] = value.end;
    }
    return { ...value, start, end };
}
export function mapFacetRequest(facetRequest, mappings) {
    if (isDateFacetRequest(facetRequest)) {
        const { facetId, currentValues } = facetRequest;
        mappings.dateFacetValueMap[facetId] = {};
        return {
            ...facetRequest,
            currentValues: currentValues.map((value) => mapDateRangeRequest(value, facetId, mappings)),
        };
    }
    return facetRequest;
}
export function mapSearchRequest(searchRequest) {
    const mappings = initialSearchMappings();
    const request = {
        ...searchRequest,
        facets: searchRequest.facets?.map((facetRequest) => mapFacetRequest(facetRequest, mappings)),
    };
    return { request, mappings };
}
function mapDateRangeResponse(value, facetId, mappings) {
    return {
        ...value,
        start: mappings.dateFacetValueMap[facetId][formatStartFacetValue(value.start)] ||
            value.start,
        end: mappings.dateFacetValueMap[facetId][formatEndFacetValue(value.end)] ||
            value.end,
    };
}
function isDateFacetResponse(facetResponse, mappings) {
    return facetResponse.facetId in mappings.dateFacetValueMap;
}
function mapFacetResponse(facetResponse, mappings) {
    if (isDateFacetResponse(facetResponse, mappings)) {
        return {
            ...facetResponse,
            values: facetResponse.values.map((value) => mapDateRangeResponse(value, facetResponse.facetId, mappings)),
        };
    }
    return facetResponse;
}
export function mapSearchResponse(response, mappings) {
    if ('success' in response) {
        const success = {
            ...response.success,
            facets: response.success.facets?.map((facetResponse) => mapFacetResponse(facetResponse, mappings)),
        };
        return { success };
    }
    return response;
}
